module.exports = __webpack_public_path__ + "static/mask_lo_061-38113d0af1ca55eb01adc04538b435e0.jpg";